import React, {memo} from 'react'
import {cache} from 'swr'
import {
  withEnvironmentData,
  withErrorHandling,
  withHelmet,
  withPropsPresent,
  withResourceData,
  withServiceData,
  withVersionData
} from '../../../../../hoc'
import {RemovalConfirmationModal} from '../../../../shared'
import {goBack} from '../../../../../util'
import {removeResource} from '../../../../../backend'

const _RemoveResource = (
  {
    service,
    version,
    environment,
    resource,
    history,
    navigate,
    mutateEnvironment,
    removeResource,
    basePath = '/c/services/:serviceId/versions/:versionId/environments/:environmentId/resources',
  }
) => {

  const getPathPrefix = () => {
    return basePath
      .replace(':serviceId', service.id)
      .replace(':versionId', version.id)
      .replace(':environmentId', environment.id)
  }

  const onRemovalConfirmed = async (resource) => {
    await removeResource(resource.id)
    cache.clear()
    mutateEnvironment()
    navigate(getPathPrefix())
  }

  const onRemovalCancelled = () => {
    goBack(history, navigate, getPathPrefix())
  }

  if (!resource) {
    return null
  }

  return (
    <RemovalConfirmationModal
      confirmingRemovalOf={`${resource.verb} ${resource.path}`}
      onRemovalApproved={async () => onRemovalConfirmed(resource)}
      onRemovalCancelled={onRemovalCancelled}/>
  )
}

let RemoveResource = (props) => {
  const {handleError} = props
  props = {
    ...props,
    history: window.history,
    removeResource: handleError(removeResource)
  }
  return (<_RemoveResource {...props}/>)
}

RemoveResource = withPropsPresent(RemoveResource, ['service', 'version', 'environment'])
RemoveResource = withHelmet(RemoveResource, 'Remove Resource')
RemoveResource = withResourceData(RemoveResource, 'Loading resource...')
RemoveResource = withEnvironmentData(RemoveResource, 'Loading environment...')
RemoveResource = withVersionData(RemoveResource, 'Loading version...')
RemoveResource = withServiceData(RemoveResource, 'Loading service...')
RemoveResource = withErrorHandling(RemoveResource, 'Loading resource...')
RemoveResource = memo(RemoveResource)

export {_RemoveResource, RemoveResource}

export default RemoveResource